import { combineReducers } from 'redux';
import show from './show';
import list from './list';
import usage from './usage';
import enableAutoRenew from './enableAutoRenew';
import disableAutoRenew from './disableAutoRenew';
import upgradeSummary from './upgradeSummary';

export default combineReducers({ show, list, usage, enableAutoRenew, disableAutoRenew, upgradeSummary });
